import { get } from '../index'

export type GetCitiesResponse = {
  cities: string[]
  nearest: string
}

export const getCities = (apiUrl: string) => get<GetCitiesResponse>(apiUrl)
